/* W-031 (C), 2026-09-30 -- THE ONE RULE FOR RE-SEEDING A SETTINGS FORM WHEN ITS STORED ROW IS REFETCHED.

   A save anywhere on a page refetches the model (markStale + ensureFresh), which hands every settings effect a NEW row
   object. The effects used to overwrite every draft from it, so an unsaved edit on one tab was silently wiped by a save
   on another tab (measured in diffs/group2-phase0.txt: a typed Company Quota churn of 25 went back to the stored 12).

   THE RULE, per field:
     - the first seed (no previous stored snapshot) takes the stored value;
     - a CLEAN draft -- equal to the PREVIOUSLY stored value -- takes the new stored value (so a refetch still refreshes it);
     - a draft equal to the NEW stored value takes it (it is the same value);
     - a DIRTY draft -- the operator changed it and has not saved it -- is KEPT;
     - a field this form has JUST SAVED (forceKeys) takes the refetched value even if the server rounded it, so after a
       field's own save its draft is clean again.
   Values are compared by content (object keys in sorted order), so a refetched copy of an unchanged map is "equal".
   It is the same idea as the misc / implementation line effects (a line keeps its existing draft), made per field. */

function stable(v) {
  if (v === null || typeof v !== 'object') return JSON.stringify(v === undefined ? null : v);
  if (Array.isArray(v)) return '[' + v.map(stable).join(',') + ']';
  return '{' + Object.keys(v).sort().map(k => JSON.stringify(k) + ':' + stable(v[k])).join(',') + '}';
}

export function sameValue(a, b) {
  return stable(a) === stable(b);
}

/* The value ONE draft field holds after a refetch. */
export function keepDirtyDraft(prevStored, nextStored, draft) {
  return sameValue(draft, prevStored) || sameValue(draft, nextStored) ? nextStored : draft;
}

/* Applies the rule to a whole form.
     setters   { key: setState } -- one per field
     prevSnap  the previous stored snapshot { key: normalised value }, or null for the first seed
     nextSnap  the new stored snapshot, normalised exactly as the form displays it
     forceKeys a Set of keys this form just saved (their refetched value is taken), or null */
export function reseedDrafts(setters, prevSnap, nextSnap, forceKeys) {
  Object.keys(setters).forEach(k => {
    const next = nextSnap[k];
    if (!prevSnap || (forceKeys && forceKeys.has(k))) { setters[k](next); return; }
    setters[k](draft => keepDirtyDraft(prevSnap[k], next, draft));
  });
}
